import { INVITE_TYPE } from '../../child/genesys/types';

const pushedEvents = [];
const isEventPushed = (engagementID, eventName) => {
    const event = engagementID + '|' + eventName;
    if (!pushedEvents.includes(event)) {
        pushedEvents.push(event);
        return false;
    }
    return true;
};

export const pushGTMEvent = ({ engagementID, event, media, cmbType, contactOptions }, Logger) => {
    window.dataLayer = window.dataLayer || [];

    if (!engagementID) {
        return;
    }

    let GMTEvent;
    if (media === INVITE_TYPE.CALL) {
        GMTEvent = {
            LeadID_CALL: engagementID,
            event: 'leadCALLSubmitted'
        };
    } else if (media === INVITE_TYPE.CALLBACK) {
        GMTEvent = {
            LeadID_CMB: engagementID,
            event: event,
            CMBType: cmbType
        };
    } else if (media === INVITE_TYPE.CHAT) {
        GMTEvent = {
            LeadID_CHAT: engagementID,
            event: event ? event : 'leadCHATClick'
        };
    } else if (media === INVITE_TYPE.CHAT_SUCCESS) {
        GMTEvent = {
            LeadID_CHAT: engagementID,
            event: 'leadCHATSubmitted'
        };
    } else if (media === INVITE_TYPE.SHOW_CALL) {
        GMTEvent = {
            LeadID_SHOW_CALL: engagementID,
            event: 'show_phone_number_widget'
        };
    } else if (media === INVITE_TYPE.WIDGET) {
        GMTEvent = {
            LeadID_WIDGET: engagementID,
            event: 'openWidget',
            contactOptions: contactOptions
        };
    }

    if (GMTEvent && !isEventPushed(engagementID, GMTEvent.event)) {
        window.dataLayer.push(GMTEvent);
        Logger.log(`[GTM] pushed event: ${GMTEvent.event}`);
    }
};
